import { useRecoilValue } from 'recoil';

import stateFilterSex from '../../state/stateFilterSex';
import stateFilterDisease from '../../state/stateFilterDisease';
import stateFilterInterProc from '../../state/stateFilterInterProc';
import stateFilterMeasure from '../../state/stateFilterMeasure';

import stateFilterVariant from '../../state/stateFilterVariant';
import stateFilterAminoacidChange from '../../state/stateFilterAminoacidChange';
import stateFilterRange from '../../state/stateFilterRange';
//import stateFilterGene from '../../state/stateFilterGene';

import stateFilterImgDisease from '../../state/stateFilterImgDisease';
import stateFilterImgMeasure from '../../state/stateFilterImgMeasure';
import stateFilterImgAnatomic from '../../state/stateFilterImgAnatomic';

import BeaconFilter from '../../models/BeaconFilter';
import BeaconFilterItemRequest from '../../models/BeaconFilterItemRequest';
import { useMemo } from 'react';

function useQuery() {
  const filterSex = useRecoilValue(stateFilterSex);
  const filterDisease = useRecoilValue(stateFilterDisease);
  const filterInterProc = useRecoilValue(stateFilterInterProc);
  const filterMeasure = useRecoilValue(stateFilterMeasure);

  const filterVariant = useRecoilValue(stateFilterVariant);
  const filterAminoacidChange = useRecoilValue(stateFilterAminoacidChange);
  const filterRange = useRecoilValue(stateFilterRange);
  //const filterGene = useRecoilValue(stateFilterGene);

  const filterImgDisease = useRecoilValue(stateFilterImgDisease);
  const filterImgMeasure = useRecoilValue(stateFilterImgMeasure);
  const filterImgAnatomic = useRecoilValue(stateFilterImgAnatomic);

  let filters = [filterSex, filterDisease, filterInterProc]
    .filter((elem) => !!elem)
    .map((elem) => ({ id: elem.id })) as BeaconFilterItemRequest[];
  if (!!filterMeasure) {
    filters.push(...[filterMeasure]);
  }

  let filtersImg: any = [];
  if (!!filterImgDisease) {
    filtersImg.push(...[filterImgDisease]);
  }
  if (!!filterImgMeasure) {
    filtersImg.push(...[filterImgMeasure]);
  }
  if (!!filterImgAnatomic) {
    filtersImg.push(...[filterImgAnatomic]);
  }

  const filter = useMemo(
    () =>
      ({
        filters: filters,
        filtersImg: filtersImg,
        variant: filterVariant,
        range: filterRange,
        //gene: filterGene,
        aminoacidChange: filterAminoacidChange,
      } as BeaconFilter),
    [
      filterSex,
      filterDisease,
      filterInterProc,
      filterMeasure,
      filterVariant,
      filterRange,
      filterAminoacidChange,
      filterImgDisease,
      filterImgMeasure,
      filterImgAnatomic,
      //    , filterGene
    ]
  );
  return filter;
}

export default useQuery;
